<template>
  <b-modal
    v-model="show"
    size="lg"
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    modal-class="whats-new-modal whats-new-modal--apple"
    body-class="whats-new-body"
    @hide="onHide"
  >
    <div v-if="localRelease" class="whats-new-shell">
      <div
        v-if="viewMode !== 'history' && items.length"
        class="whats-new-segments"
      >
        <span
          v-for="(item, index) in items"
          :key="index"
          class="whats-new-segment"
          :class="{ filled: viewMode === 'summary' || index <= step }"
        ></span>
      </div>

      <div class="whats-new-topbar">
        <div class="whats-new-topbar-left">
          <template v-if="viewMode === 'history'">
            <b-button
              variant="link"
              size="sm"
              class="whats-new-skip px-0"
              @click="viewMode = 'carousel'"
            >
              <feather-icon icon="ArrowLeftIcon" class="mr-50" />Voltar
            </b-button>
          </template>
          <template v-else>
            <span class="whats-new-badge">{{ releaseBadge }}</span>
            <span v-if="releaseDate" class="whats-new-date">{{ releaseDate }}</span>
          </template>
        </div>
        <div class="whats-new-topbar-right">
          <b-button
            v-if="viewMode === 'carousel'"
            variant="link"
            size="sm"
            class="whats-new-skip"
            @click="openSummary"
          >
            Resumo completo
          </b-button>
          <b-button
            variant="link"
            size="sm"
            class="whats-new-skip"
            @click="headerClose"
          >
            {{ closeLabel }}
          </b-button>
        </div>
      </div>

      <!-- HISTÓRICO -->
      <div v-if="viewMode === 'history'" class="whats-new-history">
        <div class="whats-new-history-body">
          <div class="whats-new-summary-head mb-2">
            <h2 class="whats-new-title">Atualizações anteriores</h2>
            <p class="whats-new-summary-sub">
              Reveja os comunicados publicados anteriormente.
            </p>
          </div>

          <div class="whats-new-summary-list">
            <div
              v-for="release in historyItems"
              :key="release.id"
              class="whats-new-history-item"
            >
              <span class="whats-new-summary-texts">
                <span class="whats-new-summary-title">
                  {{ release.title }}
                  <b-badge
                    v-if="isReleaseSeen(release)"
                    variant="light-success"
                    class="ml-50"
                    >Visto</b-badge
                  >
                </span>
                <span class="whats-new-summary-desc">
                  {{ formatDate(release.published_at) }} ·
                  {{ release.items_count || (release.items || []).length }} itens
                </span>
              </span>
              <b-button
                class="whats-new-btn-ghost whats-new-btn-sm"
                @click="reviewRelease(release)"
              >
                Visualizar
              </b-button>
            </div>

            <div v-if="!historyItems.length" class="whats-new-history-empty">
              Nenhuma atualização anterior.
            </div>
          </div>
        </div>
      </div>

      <!-- RESUMO DA RELEASE -->
      <div v-else-if="viewMode === 'summary'" class="whats-new-summary">
        <div class="whats-new-summary-body">
          <div class="whats-new-summary-head">
            <h2 class="whats-new-title">{{ summaryTitle }}</h2>
            <p class="whats-new-summary-sub">
              Estes foram os itens comunicados nesta atualização do Oráculo.
            </p>
          </div>

          <div class="whats-new-summary-list">
            <button
              v-for="(item, index) in items"
              :key="index"
              type="button"
              class="whats-new-summary-item"
              @click="goToItem(index)"
            >
              <span class="whats-new-check">
                <feather-icon icon="CheckIcon" size="14" />
              </span>
              <span class="whats-new-summary-texts">
                <span class="whats-new-summary-title">{{ item.title }}</span>
                <span class="whats-new-summary-desc">{{ item.description }}</span>
              </span>
              <b-badge v-if="item.category" class="whats-new-cat">
                {{ item.category }}
              </b-badge>
            </button>
          </div>

          <div class="whats-new-actions">
            <b-button class="whats-new-btn-ghost" @click="reviewPresentation">
              Rever apresentação
            </b-button>
            <b-button class="whats-new-btn-primary" @click="finish">
              Concluir
            </b-button>
          </div>
        </div>

        <div class="whats-new-bottom">
          <span class="whats-new-count">Resumo da release</span>
          <b-link class="whats-new-history-link" @click="openHistory">
            Atualizações anteriores ›
          </b-link>
        </div>
      </div>

      <!-- CARROSSEL -->
      <div v-else class="whats-new-carousel">
        <template v-if="currentItem">
          <div class="whats-new-stage">
            <!-- Setas ancoradas na altura da mídia: não se movem com o texto -->
            <div class="whats-new-media-row">
              <button
                type="button"
                class="whats-new-arrow whats-new-arrow--left"
                :disabled="step === 0"
                aria-label="Anterior"
                @click="prev"
              >
                <feather-icon icon="ChevronLeftIcon" size="24" />
              </button>

              <div class="whats-new-laptop">
              <div class="whats-new-device">
                <span class="whats-new-device-cam"></span>
                <div class="whats-new-screen">
                  <video
                    v-if="currentItem.video_src"
                    ref="video"
                    :key="currentItem.video_src"
                    :src="currentItem.video_src"
                    :poster="currentItem.thumbnail_url || null"
                    controls
                    autoplay
                    playsinline
                    class="whats-new-video"
                    @loadedmetadata="startPlayback"
                    @play="videoStarted = true"
                  />
                  <img
                    v-else-if="currentItem.thumbnail_url"
                    :src="currentItem.thumbnail_url"
                    alt="thumbnail"
                  />
                  <div v-else class="whats-new-media-placeholder">
                    <feather-icon icon="ImageIcon" size="48" />
                  </div>

                  <button
                    v-if="currentItem.video_src && !videoStarted"
                    type="button"
                    class="whats-new-play"
                    aria-label="Reproduzir"
                    @click="playVideo"
                  >
                    <feather-icon icon="PlayIcon" size="28" />
                  </button>
                </div>
              </div>
              <div class="whats-new-laptop-base"></div>
              </div>

              <button
                type="button"
                class="whats-new-arrow whats-new-arrow--right"
                aria-label="Próximo"
                @click="next"
              >
                <feather-icon icon="ChevronRightIcon" size="24" />
              </button>
            </div>

            <div class="whats-new-text">
              <h2 class="whats-new-title">{{ currentItem.title }}</h2>
              <p class="whats-new-desc">{{ currentItem.description }}</p>

              <div v-if="currentItem.link && !isLastItem" class="whats-new-actions">
                <b-button
                  class="whats-new-btn-primary"
                  :href="normalizeUrl(currentItem.link)"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ver a melhoria no sistema
                </b-button>
              </div>
            </div>
          </div>

          <div class="whats-new-bottom">
            <span class="whats-new-count">{{ step + 1 }} de {{ items.length }}</span>
            <b-link class="whats-new-history-link" @click="openHistory">
              Atualizações anteriores ›
            </b-link>
          </div>
        </template>

        <div v-else class="whats-new-empty">
          <p>Este comunicado ainda não possui itens.</p>
          <b-button variant="primary" @click="closeModal">Fechar</b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton, BBadge, BLink } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import * as types from "../store/types";

const MONTHS_PT = [
  "jan",
  "fev",
  "mar",
  "abr",
  "mai",
  "jun",
  "jul",
  "ago",
  "set",
  "out",
  "nov",
  "dez",
];

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BLink,
  },
  data() {
    return {
      localRelease: null,
      step: 0,
      viewedMax: 0,
      viewMode: "carousel",
      tracked: false,
      videoStarted: false,
    };
  },
  beforeDestroy() {
    document.body.classList.remove("whats-new-open");
  },
  computed: {
    ...mapGetters({
      modal: types.WHATS_NEW_MODAL,
      history: types.WHATS_NEW_HISTORY,
    }),
    show: {
      get() {
        return this.modal.visible;
      },
      set(value) {
        if (!value) this.closeModal();
      },
    },
    items() {
      return (this.localRelease && this.localRelease.items) || [];
    },
    currentItem() {
      return this.items[this.step] || null;
    },
    isLastItem() {
      return this.step >= this.items.length - 1;
    },
    releaseBadge() {
      const release = this.localRelease;
      if (!release) return "";
      return release.version ? `Release ${release.version}` : release.title || "Novidades";
    },
    releaseDate() {
      return this.localRelease
        ? this.formatDateShort(this.localRelease.published_at)
        : "";
    },
    summaryTitle() {
      const release = this.localRelease;
      if (!release) return "";
      const base = release.version
        ? `Release ${release.version}`
        : release.title || "Novidades";
      return `${base} · o que entrou`;
    },
    closeLabel() {
      return this.viewMode === "history" ? "Fechar" : "Ver depois";
    },
    historyItems() {
      return (this.history && this.history.data) || [];
    },
  },
  watch: {
    "modal.visible": function (visible) {
      if (visible) this.reset();
      document.body.classList.toggle("whats-new-open", visible);
    },
    step() {
      this.videoStarted = false;
    },
  },
  methods: {
    ...mapActions({
      closeModalAction: types.CLOSE_WHATS_NEW_MODAL,
      trackRelease: types.TRACK_WHATS_NEW,
      getHistory: types.GET_WHATS_NEW_HISTORY,
      checkCurrent: types.CHECK_CURRENT_WHATS_NEW,
    }),
    reset() {
      this.localRelease = this.modal.release;
      this.step = 0;
      this.viewedMax = 0;
      this.viewMode = "carousel";
      this.tracked = false;
      this.videoStarted = false;
    },
    prev() {
      if (this.step > 0) this.step -= 1;
    },
    next() {
      if (this.isLastItem) {
        this.openSummary();
        return;
      }
      this.step += 1;
      if (this.step > this.viewedMax) this.viewedMax = this.step;
    },
    openSummary() {
      this.viewedMax = Math.max(this.viewedMax, this.items.length - 1);
      this.viewMode = "summary";
    },
    goToItem(index) {
      this.step = index;
      this.videoStarted = false;
      this.viewMode = "carousel";
    },
    reviewPresentation() {
      this.step = 0;
      this.videoStarted = false;
      this.viewMode = "carousel";
    },
    playVideo() {
      const video = this.$refs.video;
      if (video && typeof video.play === "function") {
        video.play();
      }
    },
    // Autoplay com som; se o navegador bloquear, refaz mudo.
    startPlayback() {
      const video = this.$refs.video;
      if (!video || typeof video.play !== "function") return;
      const played = video.play();
      if (played && typeof played.catch === "function") {
        played.catch(() => {
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    },
    skip() {
      this.track("skipped");
      this.closeModal();
    },
    headerClose() {
      if (this.viewMode === "history") {
        this.closeModal();
        return;
      }
      this.skip();
    },
    finish() {
      this.track("completed", this.items.length);
      this.closeModal();
    },
    openHistory() {
      this.getHistory({ currentPage: 1 }).catch(() => {});
      this.viewMode = "history";
    },
    reviewRelease(release) {
      this.localRelease = release;
      this.step = 0;
      this.viewedMax = 0;
      this.viewMode = "carousel";
      this.videoStarted = false;
    },
    isReleaseSeen(release) {
      return (release.views || []).some((view) => view.status === "completed");
    },
    // Sem http(s), a URL viraria caminho relativo.
    normalizeUrl(url) {
      if (!url) return url;
      return /^https?:\/\//i.test(url) ? url : `https://${url}`;
    },
    formatDate(value) {
      if (!value) return "";
      const datePart = String(value).split(/[T ]/)[0];
      const dateParts = datePart.split("-");
      if (dateParts.length === 3) {
        return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
      }
      return "";
    },
    formatDateShort(value) {
      if (!value) return "";
      const datePart = String(value).split(/[T ]/)[0];
      const parts = datePart.split("-");
      if (parts.length !== 3) return "";
      const month = MONTHS_PT[parseInt(parts[1], 10) - 1] || "";
      return `${parseInt(parts[2], 10)} ${month} ${parts[0]}`;
    },
    // Grava uma vez por abertura; `completed` sobrescreve.
    track(status, itemsViewed) {
      if (!this.localRelease || !this.localRelease.id) return;
      if (this.tracked && status !== "completed") return;
      this.tracked = true;
      const viewed = itemsViewed != null ? itemsViewed : this.viewedMax + 1;
      this.trackRelease({
        id: this.localRelease.id,
        status,
        items_viewed: Math.min(viewed, this.items.length),
      })
        // Após registrar, busca o próximo pendente e abre em sequência (igual Comunicados).
        .then(() => this.checkCurrent())
        .catch(() => {});
    },
    onHide() {
      if (!this.tracked) this.track("skipped");
      this.markDismissed();
    },
    markDismissed() {
      const release = this.modal.release;
      if (release && release.id) {
        sessionStorage.setItem(
          `dismissed_whats_new_${release.id}_${release.updated_at || ""}`,
          "1"
        );
      }
    },
    closeModal() {
      this.markDismissed();
      this.closeModalAction();
    },
  },
};
</script>

<style lang="scss">
// Modal imersivo (fundo escuro fixo). Cor de destaque em --wn-accent-*.
// Esconde os botões flutuantes de suporte (App.vue) enquanto o modal está aberto.
body.whats-new-open .float-bottom-left {
  display: none !important;
}
.whats-new-modal--apple {
  .modal-dialog {
    max-width: 99vw;
    margin: 0.5vh auto;
  }
  .modal-content {
    min-height: 99vh;
    border: none;
    border-radius: 1.25rem;
    overflow: hidden;
    background: #0e0e12;
  }
}
.whats-new-body {
  padding: 0;
}

.whats-new-shell {
  --wn-accent-start: #ff8a3d;
  --wn-accent-end: #f2551f;
  --wn-text: #f3f3f6;
  --wn-muted: #9a9aa6;
  --wn-border: rgba(255, 255, 255, 0.12);

  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 99vh;
  color: var(--wn-text);
  background:
    radial-gradient(120% 60% at 50% -10%, rgba(242, 85, 31, 0.12), transparent 55%),
    #0e0e12;
}

.whats-new-segments {
  flex: 0 0 auto;
  display: flex;
  gap: 6px;
  padding: 14px 22px 0;
}
.whats-new-segment {
  flex: 1 1 0;
  height: 3px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.16);
  transition: background 0.3s;

  &.filled {
    background: linear-gradient(
      90deg,
      var(--wn-accent-start),
      var(--wn-accent-end)
    );
  }
}

.whats-new-topbar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
}
.whats-new-topbar-left {
  display: flex;
  align-items: center;
  min-width: 0;
}
.whats-new-badge {
  background: linear-gradient(135deg, var(--wn-accent-start), var(--wn-accent-end));
  color: #fff;
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 0.32rem 0.6rem;
  border-radius: 6px;
  white-space: nowrap;
}
.whats-new-date {
  margin-left: 0.85rem;
  color: var(--wn-muted);
  font-size: 0.85rem;
  white-space: nowrap;
}
.whats-new-brand {
  font-weight: 600;
  color: var(--wn-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.whats-new-skip.btn {
  color: var(--wn-muted) !important;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    color: var(--wn-text) !important;
  }
}

.whats-new-carousel {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.whats-new-stage {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // Mídia ancorada no topo: posição da mídia e das setas fica fixa.
  justify-content: flex-start;
  gap: 1.25rem;
  padding: 1vh 1rem 1rem;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.whats-new-media-row {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}
// Laptop 16:9 dimensionado pela altura; mais estreito que a linha p/ sobrar canto às setas.
.whats-new-laptop {
  width: min(88%, calc(62vh * 16 / 9));
  display: flex;
  flex-direction: column;
  align-items: center;
}
.whats-new-device {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 14px 14px 16px;
  border-radius: 16px 16px 8px 8px;
  background: linear-gradient(#2a2a33, #17171d);
  border: 1px solid rgba(255, 255, 255, 0.09);
  box-shadow: 0 24px 50px rgba(0, 0, 0, 0.5);
}
.whats-new-laptop-base {
  position: relative;
  width: 106%;
  height: 15px;
  margin-top: -2px;
  background: linear-gradient(180deg, #43434e 0%, #2b2b33 45%, #17171d 100%);
  border-radius: 3px 3px 14px 14px;
  box-shadow: 0 26px 34px rgba(0, 0, 0, 0.5);
}
.whats-new-laptop-base::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}
.whats-new-laptop-base::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 12%;
  max-width: 130px;
  height: 6px;
  background: #101015;
  border-radius: 0 0 8px 8px;
}
.whats-new-device-cam {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
}
.whats-new-screen {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: #000;

  video,
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.whats-new-media-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5a5a66;
}
.whats-new-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 4px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #15151b;
  cursor: pointer;
  box-shadow: 0 10px 34px rgba(0, 0, 0, 0.45);
  transition: transform 0.18s ease, background 0.18s ease;

  &:hover {
    transform: translate(-50%, -50%) scale(1.07);
    background: #fff;
  }
}
.whats-new-text {
  text-align: center;
  max-width: 860px;
  width: 100%;
  min-height: 8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.whats-new-title {
  font-size: 2.1rem;
  font-weight: 700;
  margin: 0.15rem 0 0.6rem;
  color: var(--wn-text);
}
.whats-new-desc {
  margin: 0 auto;
  max-width: 860px;
  color: var(--wn-muted);
  font-size: 1.12rem;
  line-height: 1.45;
  white-space: pre-line;
  // Teto de ~4 linhas: descrições longas rolam dentro da caixa.
  max-height: 6.6rem;
  overflow-y: auto;
}
.whats-new-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  justify-content: center;
  margin-top: 1.25rem;
}
.whats-new-btn-ghost.btn {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #e8e8ee;
  border-radius: 12px;
  padding: 0.85rem 1.85rem;
  font-size: 1.15rem;
  font-weight: 600;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
  }
}
.whats-new-btn-primary.btn {
  background: #ffffff;
  border: none;
  color: #15151b;
  border-radius: 12px;
  padding: 0.85rem 2.4rem;
  font-size: 1.15rem;
  font-weight: 700;

  &:hover {
    background: #f0f0f4;
    color: #15151b;
  }
}
.whats-new-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--wn-border);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: #e8e8ee;
  cursor: pointer;
  transition: transform 0.18s ease, background 0.18s ease, opacity 0.18s ease;

  &:hover:not(:disabled) {
    transform: translateY(-50%) scale(1.08);
    background: rgba(255, 255, 255, 0.14);
  }
  &:active:not(:disabled) {
    transform: translateY(-50%) scale(0.96);
  }
  &:disabled {
    opacity: 0.28;
    cursor: default;
  }
  &--left {
    left: 0.75rem;
  }
  &--right {
    right: 0.75rem;
  }
}

.whats-new-bottom {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.75rem 1.25rem;
}
.whats-new-count {
  color: var(--wn-muted);
  font-size: 0.85rem;
}
.whats-new-history-link {
  color: var(--wn-muted);
  cursor: pointer;

  &:hover {
    color: var(--wn-text);
  }
}

.whats-new-empty {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: var(--wn-muted);
}

.whats-new-summary {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.whats-new-summary-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 1rem 2rem;
  min-height: 0;
  overflow-y: auto;
}
.whats-new-summary-head {
  text-align: center;
}
.whats-new-summary-sub {
  margin: 0.35rem 0 0;
  color: var(--wn-muted);
  font-size: 1rem;
}
.whats-new-summary-list {
  width: 100%;
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
.whats-new-summary-item {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  width: 100%;
  text-align: left;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  color: var(--wn-text);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.18);
  }
}
.whats-new-check {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, var(--wn-accent-start), var(--wn-accent-end));
}
.whats-new-summary-texts {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.whats-new-summary-title {
  font-weight: 700;
  color: var(--wn-text);
}
.whats-new-summary-desc {
  color: var(--wn-muted);
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.whats-new-cat.badge {
  flex: 0 0 auto;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #c9c9d2;
  font-weight: 600;
  border-radius: 999px;
  padding: 0.32rem 0.7rem;
}

.whats-new-history {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  min-height: 0;
  overflow: hidden;
}
.whats-new-history-body {
  width: 100%;
  max-width: 1040px;
  max-height: 100%;
  overflow-y: auto;
}
.whats-new-history-item {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  width: 100%;
  padding: 0.9rem 1.1rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  color: var(--wn-text);
}
.whats-new-history-empty {
  text-align: center;
  color: var(--wn-muted);
  padding: 2rem 0;
}
.whats-new-btn-sm.btn {
  flex: 0 0 auto;
  padding: 0.45rem 1.1rem;
  font-size: 0.9rem;
}

@media (max-width: 767.98px) {
  .whats-new-modal--apple .modal-dialog {
    max-width: 100vw;
    margin: 0;
  }
  .whats-new-modal--apple .modal-content {
    min-height: 100vh;
    border-radius: 0;
  }
  .whats-new-shell {
    min-height: 100vh;
  }
  .whats-new-stage {
    padding: 0 1rem;
    gap: 1rem;
  }
  .whats-new-media-row {
    gap: 0.5rem;
  }
  .whats-new-arrow {
    width: 38px;
    height: 38px;
  }
  .whats-new-title {
    font-size: 1.35rem;
  }
}
</style>
